import { datasource } from "./datasource";

export const ballDrilledDS = (currentUserId, actions) => () =>
  datasource(currentUserId, actions)("ball_drilled", {
    model: {
      id: "id",
      fields: {
        id: {
          type: "string",
        },
        customer_id: {
          type: "string",
        },
        customer: {
          type: "string",
        },
        ball_name: {
          type: "string",
        },
        serial_number: {
          type: "string",
        },
        manufacturer: {
          type: "string",
        },
        date_drilled: {
          type: "string",
        },
        drilling_angle: {
          type: "string",
          calculated: true,
        },
        pin_to_pap: {
          type: "string",
          calculated: true,
        },
        val_angle: {
          type: "string",
          calculated: true,
        },
        psa_to_pap: {
          type: "string",
          calculated: true,
        },
        pin_buffer: {
          type: "string",
          calculated: true,
        },
        layout_type: {
          type: "string",
        },
        layout: {
          type: "string",
        },
        surface_preparation: {
          type: "string",
        },
        weight: {
          type: "string",
        },
        weight_hole_position: {
          type: "string",
        },
        weight_hole_size: {
          type: "string",
        },
        weight_hole_depth: {
          type: "string",
        },
        spec_sheet: {
          type: "raw",
        },
        spec_sheet_id: {
          type: "string",
        },
        photo: {
          type: "raw",
        },
        position: {
          type: "number",
          alter: true,
        },
        enable: {
          type: "boolean",
          alter: true,
        },
        note: {
          type: "string",
          alter: true,
        },
        date_drilled: {
          type: "string",
          alter: true,
        },
        rg: {
          type: "string",
          alter: true,
        },
        diff: {
          type: "string",
          alter: true,
        },
        int_diff: {
          type: "string",
          alter: true,
        },
        core: {
          type: "string",
          alter: true,
        },
        cover: {
          type: "string",
          alter: true,
        },
        jobs: {
          type: "raw",
        },
        created_at: {
          type: "string",
        },
        updated_at: {
          type: "string",
        },
        created_by: {
          type: "string",
        },
        updated_by: {
          type: "string",
        },
        thumb_depth: {
          type: "string"
        },
        f1_depth: {
          type: "string"
        },
        f2_depth: {
          type: "string"
        },
        extra_values: {
          type: "raw",
          alter: true,
        },
      },
    },
  });
